import { ModalDialog } from '@launchpad';
import AppTable, { IdButton } from '@launchpad/components/crud/AppTable';
import React, { useState } from 'react';
import { AppBadge } from '@launchpad/components/typography';
import AuthorisationImportFileRowModel from '../../models/AuthorisationImportFileRowModel';

type UploadNewFileModalProps = {
  file: { id: string };
};

type AuthorisationImportFileRow = {
  id: string;
  createdAt: string;
  additionalData: Record<string, string>;
  payload: Record<string, unknown> | null;
  rowIndex: number;
  paymentDeviceId: string | null;
  accountId: string | null;
  status: string;
};

export const AuthorisationImportFileRows = (props: UploadNewFileModalProps) => {
  const [
    currentItem,
    setCurrentItem,
  ] = useState<AuthorisationImportFileRow | null>(null);
  return (
    <>
      <ModalDialog show={!!currentItem} onClose={() => setCurrentItem(null)}>
        {currentItem ? (
          <div className="main">
            <div className="customers-info">
              <div className="customer-details">
                <h2 className="customer-name">
                  <span className="company">{currentItem.id}</span>
                </h2>
              </div>

              <div className="customers-main">
                <div className="row">
                  <div className="col">
                    <div className="padded">
                      <div className="row text-white">
                        <div className="col-lg-12">
                          <h4>Info</h4>
                          <hr />
                          <dl>
                            <dt>Id:</dt>
                            <dd>{currentItem.id || '-'}</dd>
                          </dl>
                          <dl>
                            <dt>Status:</dt>
                            <dd>
                              <AppBadge text={currentItem.status} />
                            </dd>
                          </dl>
                          <dl>
                            <dt>Row Index:</dt>
                            <dd>{currentItem.rowIndex}</dd>
                          </dl>
                          <dl>
                            <dt>Payment Device:</dt>
                            <dd>{currentItem.paymentDeviceId || '-'}</dd>
                          </dl>
                          <dl>
                            <dt>Account Id:</dt>
                            <dd>{currentItem.accountId || '-'}</dd>
                          </dl>
                          <dl>
                            <dt>Payload:</dt>
                            <dd>
                              {currentItem.payload ? (
                                <pre
                                  style={{ textAlign: 'left', color: 'white' }}
                                >
                                  {JSON.stringify(currentItem.payload, null, 2)}
                                </pre>
                              ) : (
                                '-'
                              )}
                            </dd>
                          </dl>
                          <dl>
                            <dt>Other data:</dt>
                            <dd>
                              {currentItem.additionalData ? (
                                <pre
                                  style={{ textAlign: 'left', color: 'white' }}
                                >
                                  {JSON.stringify(
                                    currentItem.additionalData,
                                    null,
                                    2
                                  )}
                                </pre>
                              ) : (
                                '-'
                              )}
                            </dd>
                          </dl>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </ModalDialog>
      <AppTable
        icon="list"
        title="File rows"
        filter={[
          {
            name: 'term',
            type: 'term',
          },
          {
            name: 'status',
            type: 'select',
            options: {
              options: [
                { id: '', name: 'All' },
                { id: 'PENDING_PROCESSING', name: 'Pending Processing' },
                {
                  id: 'PROCESSING_IN_PROGRESS',
                  name: 'Processing In Progress',
                },
                { id: 'PROCESSED', name: 'Processed' },
                {
                  id: 'PROCESSED_TEMENOS_REQUEST_FAILED',
                  name: 'Processed Temenos Request Failed',
                },
                { id: 'PROCESSED_WITH_ERRORS', name: 'Processed With Errors' },
                {
                  id: 'PROCESSED_NOT_ALL_MATCHED',
                  name: 'Processed Not All Matched',
                },
                { id: 'FAILED', name: 'Failed' },
              ],
            },
            defaultValue: '',
          },
        ]}
        order={[
          {
            field: 'id',
            direction: 'desc',
          },
        ]}
        params={{
          id: props.file.id,
        }}
        model={AuthorisationImportFileRowModel}
        renderCell={(column, item, index) => {
          switch (column.name) {
            case 'id':
            case 'paymentDeviceId':
            case 'accountId':
              return item[column.name] ? (
                <IdButton value={item[column.name]} />
              ) : (
                '-'
              );
            case 'payload.USER_ID':
              return item.payload?.USER_ID ? (
                <IdButton value={item.payload?.USER_ID} />
              ) : (
                '-'
              );
            case 'status':
              return (
                <AppBadge
                  text={item.status}
                  type={
                    ['fail', 'error'].some((x) =>
                      item.status.toLowerCase().includes(x)
                    )
                      ? 'danger'
                      : 'success'
                  }
                />
              );

            default:
              return undefined;
          }
        }}
        getColumnActions={(file, index) => {
          return (
            <div>
              <button
                type="button"
                onClick={() => setCurrentItem(file)}
                className="button-info"
              >
                Details
              </button>
            </div>
          );
        }}
      />
    </>
  );
};

export default AuthorisationImportFileRows;
